export default "__VITE_PUBLIC_ASSET__ed04712b__"